import { Button, PlusIcon, Stack } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type Props = {
  handleOpenCreateModal: () => void;
};

export const PortalListEmptyPresentation: React.FC<Props> = ({ handleOpenCreateModal }) => {
  return (
    <div className={styles.container}>
      <Stack gap={24} height='100%' alignItems='center' justifyContent='center'>
        <img src='/portal-empty.png' alt='empty list image' />
        <Stack gap={16} alignItems='center' justifyContent='center'>
          <p className={styles.emptyText}>作成済みのポータルはまだありません</p>
          <Button onClick={handleOpenCreateModal} icon={<PlusIcon />} iconPosition='left'>
            新規作成
          </Button>
        </Stack>
      </Stack>
    </div>
  );
};
